var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-2 w-full bg-gray-200 mt-2 rounded"},[_c('div',{staticClass:"h-2 rounded animated-bar",class:{
      'w-0': _vm.value.length < _vm.minLength,
      'w-1/5': _vm.value.length >= _vm.minLength && _vm.result.score === 0,
      'w-2/5': _vm.value.length >= _vm.minLength && _vm.result.score === 1,
      'w-3/5': _vm.value.length >= _vm.minLength && _vm.result.score === 2,
      'w-4/5': _vm.value.length >= _vm.minLength && _vm.result.score === 3,
      'w-full': _vm.value.length >= _vm.minLength && _vm.result.score === 4,
      'bg-red-400': _vm.result.score <= 1,
      'bg-orange-400': _vm.result.score === 2,
      'bg-yellow-400': _vm.result.score === 3,
      'bg-green-400': _vm.result.score === 4
    }})])}
var staticRenderFns = []

export { render, staticRenderFns }